/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unknown-property */
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Box,
  Text,
  HStack,
  FormControl,
  Select,
  FormLabel,
  InputGroup,
  Input,
  Button,
  Flex,
  Checkbox,
  FormErrorMessage,
  FormHelperText,
  Heading,
  AvatarGroup,
  Avatar
} from '@chakra-ui/react'
import { removePlusSign } from 'utils/functions/formatNumber'
import InputMask from 'react-input-mask'
import { useForm } from 'react-hook-form'
import { PenTool, User } from 'react-feather'
import countriesMock from 'services/mock/countries.json'
import settingValidate from 'utils/validation/settingValidate'
import { isValidCuil, isSuccessStatus, maxLengthcodArea, maxLengthNumber } from 'utils/functions/validations'
import { useProviderCollaborator } from 'providers/CollaboratorsProvider'
import './CollaboratorsModal.css'
import { postValidateEmailExist, validateCollaborator } from 'services/api'
import { IResponseGeneric, IValidateCollaborator } from 'services/IApi.d'
import IbBadge from 'components/common/IbBadge'
import LoadingScreen from 'components/common/LoadingScreen/LoadingScreen'
import { numberFormatter } from 'utils/functions/formatString'
import { ICollaborators } from './interfaces.d'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
export interface collabotator {
  id: number
  rol: string[]
  nacionalidad: string
  tipoDocumento: string
  documento: string
  email: string
  esSuscriptor: boolean
  nombre: string
  apellido: string
  codPais: string
  phoneNumber: string
  codArea: string
}
interface CollaboratorsModalProps {
  isOpen: boolean
  onClose: () => void
  setShowModal: Dispatch<SetStateAction<boolean>>
  collaboratorEditInfo?: ICollaborators
  setCollaboratorEditInfo?: Dispatch<SetStateAction<object>>
  setUpdateListCollaborators?: Dispatch<SetStateAction<object>>
  listCollaborators: Array<object>
  isPhysicSubscription: boolean
}
const CollaboratorsModal: React.FC<CollaboratorsModalProps> = ({
  isOpen,
  onClose,
  collaboratorEditInfo,
  setCollaboratorEditInfo,
  setShowModal,
  setUpdateListCollaborators,
  listCollaborators,
  isPhysicSubscription,
}) => {
  const {
    role = [],
    nacionality: nacionalidadEdit = 'AR',
    documentType: tipoDocumento = 'CUIL',
    document: documento = '',
    email: emailEdit = '',
    name: nombreEdit = '',
    lastName: apellidoEdit = '',
    codPais: codPaisEdit = 'AR',
    codArea: codAreaEdit = '',
    phoneNumber: phoneNumberEdit = '',
  } = collaboratorEditInfo ?? {}
  const countries = countriesMock.data.paisList.filter(pais => pais.paisCodTel)
  const { roles } = useProviderCollaborator()
  const {
    handleSubmit,
    register,
    unregister,
    setValue,
    setError,
    getValues,
    watch,
    clearErrors,
    formState: { errors, isSubmitting, isDirty, isValid },
  } = useForm<collabotator>({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: {
      rol: role ? role.map(rol => rol.toString()) : [],
      nacionalidad: nacionalidadEdit,
      tipoDocumento:
        tipoDocumento === 'PASAPORTE'
          ? 'PASAPORTE'
          : nacionalidadEdit === 'AR'
            ? 'CUIL'
            : tipoDocumento === 'DOCUMENTO EXTRANJERO'
              ? 'DOCUMENTO EXTRANJERO'
              : '',
      documento,
      email: emailEdit,
      nombre: nombreEdit,
      apellido: apellidoEdit,
      codPais: countries.find(country => country.codDN === codPaisEdit || country.paisCodTel === codPaisEdit).codDN,
      phoneNumber: phoneNumberEdit,
      codArea: codAreaEdit,
    },
  })
  const nationality = watch('nacionalidad')
  const codPaisWatch = watch('codPais')
  const codAreaWatch = watch('codArea')
  const phoneNumberWatch = watch('phoneNumber')
  const nonCuil = ['PASAPORTE', 'DOCUMENTO EXTRANJERO']
  const typesDocuments = nationality === 'AR' ? ['CUIL'] : nonCuil
  const [maskDocument, setMaskDocument] = useState<string | null>()
  const [countryFlag, setCountryFlag] = useState<string>('ar')
  const [isDisabledDocument, setIsDisabledDocument] = useState<boolean | null>(true)
  const [loading, setLoading] = useState<boolean>(true)
  const [loadCollaboratorData, setLoadCollaboratorData] = useState<boolean>(false)
  const [stateResponse, setStateResponse] = useState<boolean>(true)
  const [msgColaborator, setMsgColaborator] = useState<string>(null)
  const [statusValidateCollaborator, setStatusValidateCollaborator] = useState<boolean>(false)
  const [isEmailValidateRegister, setIsEmailValidateRegister] = useState<boolean>(false)
  const { executeRecaptcha } = useGoogleReCaptcha()
  const isDisabledButtonFRegister = (): boolean =>
    !isDirty || !isValid || isSubmitting || statusValidateCollaborator || loadCollaboratorData || isEmailValidateRegister
  const isDisabledInputs = stateResponse && !collaboratorEditInfo
  const showtextifArg = codPaisWatch === 'AR' ? 'Ingresá el código de área sin el 0 y el número sin el 15' : ''
  const msgValidatePhone = 'El formato del teléfono no es válido'
  const errorEmailRegist = 'Ya tenés una persona registrada con ese email'
  const limitPhoneNumber = 14

  const resetValidation = e => {
    const value = e.target.name
    if (value === 'documento') {
      setMsgColaborator(null)
      setStatusValidateCollaborator(false)
    }
    clearErrors([e.target.name])
    if (value === 'codArea' || value === 'phoneNumber') {
      if (getValues('codArea').length > 1) {
        clearErrors(['phoneNumber', 'codArea', 'codPais'])
      }
    }
  }

  const findNumberCodPais = (value: string) => countries.find(country => country.codDN === value || country.paisCodTel === value)
  const countryPhoneCodeLength: number = +findNumberCodPais(codPaisWatch).paisCodTel.length || 0
  const countryCodAreaLength: number = codAreaWatch.length
  const phoneLength: number = phoneNumberWatch.length

  const charCodAreaPhoneLength = countryCodAreaLength + phoneLength
  const returnMaxPhone = (): number => countryPhoneCodeLength + charCodAreaPhoneLength

  const validateEmail = async e => {
    const email = e.target.value
    if (!email) {
      clearErrors('email')
      return
    }
    const normalizedEmail = email.toLowerCase();
    const isFormatValid = settingValidate.email.validate(normalizedEmail)
    if (typeof isFormatValid === 'string') {
      return isFormatValid
    }
    try {
      const existsEmailInList = !collaboratorEditInfo && listCollaborators.find((item: any) => item.email.toLowerCase() === normalizedEmail)
      const recaptchaToken: string = await executeRecaptcha('emailExist')
      const response: IResponseGeneric = await postValidateEmailExist(normalizedEmail, recaptchaToken)
      if (existsEmailInList) {
        setIsEmailValidateRegister(true)
        setError('email', {
          type: 'manual',
          message: errorEmailRegist,
        })
        return
      } else if (!existsEmailInList && !isSuccessStatus(response.status)) {
        setIsEmailValidateRegister(true)
        setError('email', {
          type: 'manual',
          message: errorEmailRegist,
        })
        return
      } else {
        clearErrors('email')
        setIsEmailValidateRegister(false)
        return
      }
    } catch (error) {
      return 
    }
  }

  const handleChange = (e, field) => {
    const valueField = e.target.value
    if (field === 'nombre' || field === 'apellido') {
      const onlyLetters = valueField.replace(/[^a-zñ´áéíóú ]+/gi, '')
      setValue(field, onlyLetters, { shouldValidate: true })
    }

    if (field === 'codArea') {
      const onlyNumber = numberFormatter(valueField)
      setValue(field, onlyNumber, { shouldValidate: true })
    }

    if (field === 'phoneNumber') {
      const onlyNumber = numberFormatter(valueField)
      setValue(field, onlyNumber, { shouldValidate: true })
    }

    if (field === 'tipoDocumento') {
      setValue('documento', '')
      setMsgColaborator(null)
    }

    if (field === 'nacionalidad') {
      setValue('documento', '')
      setValue('tipoDocumento', typesDocuments[0])
      if (!collaboratorEditInfo) {
        setValue('codPais', valueField, { shouldValidate: true })
        setCountryFlag(valueField.toLowerCase())
      }
    }

    if (field === 'codPais') {
      setCountryFlag(findNumberCodPais(valueField)?.codDN?.toLowerCase())
      const limitChar = charCodAreaPhoneLength + +findNumberCodPais(e.target.value).paisCodTel.length
      if (limitChar > 14) {
        setError(field, {
          type: 'manual',
          message: msgValidatePhone,
        })
      } else {
        clearErrors(['codPais', 'codArea', 'phoneNumber'])
      }
      setValue('codArea', '', { shouldValidate: false })
      setValue('phoneNumber', '', { shouldValidate: false })
    }
  }

  const fillFields = fields => {
    const { name, lastName, email, codPais, phoneNumber } = fields
    setValue('nombre', name || '', { shouldValidate: true })
    setValue('apellido', lastName || '', { shouldValidate: true })
    email && setValue('email', email, { shouldValidate: true })
    codPais && setValue('codPais', codPais, { shouldValidate: true })
    phoneNumber && setValue('phoneNumber', phoneNumber, { shouldValidate: true })
  }

  const removeDash = e => e.replaceAll('-', '')

  const handleBlur = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const document = e.target.value

    if (document !== '') {
      const documentNoDash = removeDash(document)
      const existsDocumentInList = !collaboratorEditInfo && listCollaborators.find((item: any) => item.document === documentNoDash)

      if (existsDocumentInList) {
        setMsgColaborator('La persona ingresada ya se encuentra cargado como colaborador.')
        setStatusValidateCollaborator(true)
        return
      }

      if (getValues('tipoDocumento') === 'CUIL') {
        const cuil = isValidCuil(documentNoDash)
        if (!cuil) {
          setMsgColaborator(null)
          setStatusValidateCollaborator(false)
          fillFields({
            name: getValues('nombre') || '',
            lastName: getValues('apellido') || '',
            email: getValues('email') || '',
            phoneNumber: getValues('phoneNumber') || '',
          })
          return
        }
      }

      const findColaborator: IValidateCollaborator = {
        numeroDocumento: documentNoDash,
        pais: getValues('nacionalidad'),
      }
      setLoadCollaboratorData(true)
      const { status, data } = await validateCollaborator(findColaborator)
      if (isSuccessStatus(status)) {
        const { nombre: name = '', apellido: lastName = '' } = data
        const existsDocumentInData = name && lastName
        let message = null

        if (existsDocumentInData) {
          const isAdminSelected = getValues('rol').includes('1')
          message = isAdminSelected
            ? 'Esta persona ya es usuaria de Interbanking. La vincularemos a tu empresa y la notificaremos por email.'
            : null
        }

        setMsgColaborator(message)
        setLoadCollaboratorData(false)
        setStateResponse(false)
        fillFields({ name, lastName })
      } else {
        setLoadCollaboratorData(false)
        setStateResponse(false)
        fillFields({ name: '', lastName: '' })
        setMsgColaborator(null)
        setStatusValidateCollaborator(false)
      }
    }
  }

  const closeModal = () => {
    setShowModal(false)
    setCollaboratorEditInfo(null)
    onClose()
  }

  const onSubmit = data => {
    const editedCollaborator = collaboratorEditInfo
      ? {
        id: collaboratorEditInfo.id,
        role: data.rol.map(rol => +rol),
        nacionality: data.nacionalidad,
        documentType: data.tipoDocumento,
        document: data.documento,
        esSuscriptor: false,
        email: data.email,
        name: data.nombre,
        lastName: data.apellido,
        codArea: data.codArea,
        codPais: removePlusSign(findNumberCodPais(data.codPais).paisCodTel),
        phoneNumber: removePlusSign(data.phoneNumber),
      }
      : {
        name: data.nombre,
        lastName: data.apellido,
        nacionality: data.nacionalidad,
        document: removeDash(data.documento),
        esSuscriptor: false,
        documentType: data.tipoDocumento,
        email: data.email,
        role: isPhysicSubscription ? [1] : data.rol.map(rol => +rol),
        codArea: data.codArea,
        codPais: removePlusSign(findNumberCodPais(data.codPais).paisCodTel),
        phoneNumber: removePlusSign(data.phoneNumber),
      }
    setUpdateListCollaborators(editedCollaborator)
    closeModal()
  }

  useEffect(() => {
    if (roles?.length > 0) {
      setLoading(false)
    }
  }, [roles])

  useEffect(() => {
    const nacionalidad = watch('nacionalidad')
    const codPais = watch('codPais')
    if (nacionalidad !== '') {
      setIsDisabledDocument(false)
      setCountryFlag(codPais.toLowerCase())
      if (nacionalidad === 'AR') {
        unregister('documento')
        setValue('tipoDocumento', 'CUIL')
        setMaskDocument('99-99999999-9')
        register('documento', { ...settingValidate.cuil })
        setMsgColaborator(null)
      } else {
        unregister('documento')
        // eslint-disable-next-line no-nested-ternary
        const documentTypeCopy =
          tipoDocumento === 'PASAPORTE'
            ? 'PASAPORTE'
            : nacionalidad === 'AR'
              ? 'CUIL'
              : tipoDocumento === 'DOCUMENTO EXTRANJERO'
                ? 'DOCUMENTO EXTRANJERO'
                : 'PASAPORTE'
        setValue('tipoDocumento', documentTypeCopy)
        setMaskDocument('***************')
        register('documento', { ...settingValidate.documento })
        setMsgColaborator(null)
      }
    } else {
      setIsDisabledDocument(true)
    }
  }, [watch('nacionalidad'), watch('codPais')])

  return (
    <Modal isOpen={isOpen} onClose={closeModal} size={isPhysicSubscription ? '4xl' : '6xl'}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Box textAlign='center' mt={14}>
            <Heading textStyle='h3Bold'>
              Contanos más sobre la persona elegida
            </Heading>
          </Box>
        </ModalHeader>
        <ModalCloseButton />
        {!loading && (
          <ModalBody>
            {!isPhysicSubscription && (
              <>
                <Text textStyle='h5Bold' textAlign='center'>
                  ¿Qué roles tendrá?
                </Text>
                <HStack spacing='24px' mt='10px' pb='40px' justifyContent='center'>
                  {roles?.map(({ id, rol, detalle, codigoRol }) => (
                    <Box w='lg' key={id}>
                      <Flex
                        border='1px solid'
                        borderColor='secondary.60'
                        borderRadius='12px'
                        minH='132px'
                        overflow='hidden'
                        >
                        <Checkbox
                          id='colabCheck'
                          data-testid={`rol-${codigoRol}`}
                          name='rol'
                          value={codigoRol}
                          p={6}
                          size='lg'
                          {...register('rol', settingValidate.rol)}
                        >
                          <Flex direction='row' marginLeft={4} alignItems='center'>
                            <Box flex={4}>
                              <Text textStyle='titleMdBold' color='grey.120'>
                                {rol}
                              </Text>
                              <Text textStyle='bodyMdSemi' color='grey.120'>{detalle}</Text>
                            </Box>
                            <Flex flex={1} justifyContent='flex-end'>
                              {codigoRol === 1 ? <PenTool strokeWidth={2} stroke='#2675DF' /> : <User strokeWidth={2} stroke='#2675DF' />}
                            </Flex>
                          </Flex>
                        </Checkbox>
                      </Flex>
                    </Box>
                  ))}
                </HStack>
              </>
            )}
            <Text textStyle='h5Bold' textAlign='center'>
              ¿Quién es esta persona?
            </Text>
            {msgColaborator && (
              <Flex justifyContent='center' pt={5}>
                <IbBadge variant='neutral-dark' fontSize='12px' borderRadius='2xl' py={1}>
                  <Text data-testid='msjError' p='7px' textAlign='left'>
                    {msgColaborator}
                  </Text>
                </IbBadge>
              </Flex>
            )}
            <form onSubmit={handleSubmit(onSubmit)} data-testid='form-collaborator'>
              <HStack justifyContent='center' mb='20px'>
                <Box w='315px'>
                  <FormControl isInvalid={!!errors.nacionalidad} className={`float ${watch('nacionalidad') ? 'hasValue' : ''}`}>
                    <FormHelperText> País emisor del documento</FormHelperText>
                    <Select
                      placeholder=' '
                      onFocus={e => resetValidation(e)}
                      data-testid='nacionalidad'
                      {...register('nacionalidad', {
                        ...settingValidate.nacionalidad,
                        onChange: e => {
                          handleChange(e, 'nacionalidad')
                        },
                      })}
                    >
                      {countries.map(({ nombre, codDN }) => (
                        <option value={codDN} key={nombre}>
                          {nombre}
                        </option>
                      ))}
                    </Select>
                    <FormErrorMessage>{errors?.nacionalidad && errors.nacionalidad?.message}</FormErrorMessage>
                  </FormControl>
                </Box>
                <Box w='315px'>
                  <FormControl
                    isInvalid={!!errors.tipoDocumento || !!errors.documento}
                    className={`float ${watch('tipoDocumento') ? 'hasValue' : ''}`}
                  >
                    <FormHelperText>Documento</FormHelperText>
                    <InputGroup>
                      <Select
                        roundedRight='0'
                        disabled={isDisabledDocument}
                        data-testid='tipoDocumento'
                        {...register('tipoDocumento', {
                          ...settingValidate.tipoDocumento,
                          onChange: e => {
                            handleChange(e, 'tipoDocumento')
                          },
                        })}
                      >
                        {typesDocuments.map(document => (
                          <option value={document} key={document}>
                            {document}
                          </option>
                        ))}
                      </Select>
                      <Input
                        type='text'
                        as={InputMask}
                        mask={maskDocument}
                        maskChar={null}
                        disabled={isDisabledDocument}
                        roundedLeft='0'
                        onFocus={e => resetValidation(e)}
                        defaultValue={documento}
                        placeholder='Número'
                        data-testid='documento'
                        {...register('documento', {
                          ...settingValidate.documento,
                          onBlur: e => {
                            handleBlur(e)
                          }
                        })}
                      />
                    </InputGroup>
                    <FormErrorMessage>{errors?.documento && errors.documento?.message}</FormErrorMessage>
                  </FormControl>
                </Box>
              </HStack>
              <HStack justifyContent='center' mb='20px'>
                <Box w='315px'>
                  <FormControl isInvalid={!!errors.nombre}>
                    <FormHelperText>Nombre</FormHelperText>
                    <Input
                      disabled={isDisabledInputs}
                      type='text'
                      placeholder='Nombre'
                      data-testid='nombre'
                      maxLength={30}
                      onFocus={e => resetValidation(e)}
                      {...register('nombre', {
                        ...settingValidate.nombre,
                        onChange: e => {
                          handleChange(e, 'nombre')
                        },
                      })}
                    />
                    <FormErrorMessage>{errors?.nombre && errors.nombre?.message}</FormErrorMessage>
                  </FormControl>
                </Box>
                <Box w='315px'>
                  <FormControl isInvalid={!!errors.apellido}>
                    <FormHelperText>Apellido</FormHelperText>
                    <Input
                      disabled={isDisabledInputs}
                      type='text'
                      placeholder='Apellido'
                      data-testid='apellido'
                      maxLength={25}
                      onFocus={e => resetValidation(e)}
                      {...register('apellido', {
                        ...settingValidate.nombre,
                        onChange: e => {
                          handleChange(e, 'apellido')
                        },
                      })}
                    />
                    <FormErrorMessage>{errors?.apellido && errors.apellido?.message}</FormErrorMessage>
                  </FormControl>
                </Box>
              </HStack>
              <HStack justifyContent='center' mb='24px'>
                <Box w='315px'>
                  <FormControl isInvalid={!!errors.email}>
                    <FormHelperText>Email</FormHelperText>
                    <Input
                      type='text'
                      placeholder='Email'
                      data-testid='email'
                      onFocus={e => resetValidation(e)}
                      maxLength={80}
                      {...register('email', {
                        ...settingValidate.email,
                        onBlur: e => {
                          validateEmail(e)
                        }
                      })}
                    />
                    <FormErrorMessage>{errors?.email && errors.email?.message}</FormErrorMessage>
                  </FormControl>
                </Box>
                <Box w='315px' data-testid='phoneInputs'>
                  <FormControl
                    isInvalid={!!errors.codPais || !!errors.codArea || !!errors.phoneNumber}
                    className={`float ${watch('codPais') ? 'hasValue' : ''}`}
                  >
                    <FormHelperText>Teléfono</FormHelperText>
                    <InputGroup>
                      <Box
                        data-testid='areaCodeFlag'
                        position='absolute'
                        left={2}
                        height='100%'
                        display='inline-flex'
                        justifyContent='center'
                        alignItems='center'
                        pointerEvents='none'
                        top='50%'
                        transform='translateY(-50%)'
                      >
                        <AvatarGroup>
                          <Avatar size='xs' src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${codPaisWatch}.svg`} />
                        </AvatarGroup>
                      </Box>
                      <Select
                        minW='100px'
                        variant='flag'
                        data-testid='codPais'
                        fontSize='14px'
                        {...register('codPais', {
                          ...settingValidate.codPais,
                          onChange: e => {
                            handleChange(e, 'codPais')
                          },
                        })}
                      >
                        {countries.map(({ codDN, paisCodTel }) => (
                          <option value={codDN} key={codDN}>
                            +{paisCodTel}
                          </option>
                        ))}
                      </Select>
                      <Input
                        type='text'
                        minW='70px'
                        maxW='90px'
                        onFocus={e => resetValidation(e)}
                        maxLength={maxLengthcodArea(phoneLength, countryPhoneCodeLength, countryCodAreaLength)}
                        placeholder='Código'
                        data-testid='codArea'
                        mx={2}
                        w='60%'
                        {...register('codArea', {
                          ...settingValidate.codArea,
                          validate: () => returnMaxPhone() <= limitPhoneNumber || msgValidatePhone,
                          onChange: e => {
                            handleChange(e, 'codArea')
                          },
                        })}
                      />
                      <Input
                        type='text'
                        minW='110px'
                        maxW='130px'
                        onFocus={e => resetValidation(e)}
                        maxLength={maxLengthNumber(countryPhoneCodeLength, countryCodAreaLength)}
                        placeholder='Número'
                        data-testid='phoneNumber'
                        {...register('phoneNumber', {
                          ...settingValidate.phoneNumber,
                          validate: () => returnMaxPhone() <= limitPhoneNumber || msgValidatePhone,
                          onChange: e => {
                            handleChange(e, 'phoneNumber')
                          },
                        })}
                      />
                    </InputGroup>
                    {errors?.phoneNumber || errors?.codArea || errors?.codPais ? (
                      <FormErrorMessage>
                        {errors.phoneNumber?.message || errors.codArea?.message || errors.codPais?.message}
                      </FormErrorMessage>
                    ) : (
                      <FormHelperText position='absolute' textStyle='bodySm' fontSize='12px'>{showtextifArg}</FormHelperText>
                    )}
                  </FormControl>
                </Box>
              </HStack>
              <HStack justifyContent='center' pb='25px' pt='35px'>
                <Button data-testid='cancelar' w='100px' variant='outline' color='primary.500' borderColor='primary.500' onClick={closeModal}>
                  Cancelar
                </Button>
                <Button data-testid='agregar' type='submit' w='100px' disabled={isDisabledButtonFRegister()}>
                  Agregar
                </Button>
              </HStack>
            </form>
            {loadCollaboratorData && <LoadingScreen />}
          </ModalBody>
        )}
      </ModalContent>
    </Modal>
  )
}

export default CollaboratorsModal
